function geoCodesToPayload(geoCodes) {
  if (!geoCodes) {
    return null;
  }

  if (geoCodes.size === 0) {
    return null;
  }

  return geoCodes
    .filter((geocode) => geocode)
    .map((geoCode) => (geoCode.distance ? `${geoCode.id}:${geoCode.distance}` : `${geoCode.id}`))
    .join(',');
}

export function filtersToPayload(filters) {
  if (!filters) {
    return filters;
  }

  const geoCodesFilter = filters.geoCodes ? { geoCodes: geoCodesToPayload(filters.geoCodes) } : {};

  return {
    ...filters,
    ...geoCodesFilter,
  };
}
